import {Link} from '@shopify/hydrogen';
import {useEffect, useState} from 'react';
import {Image} from '@shopify/hydrogen';

export default function BlogListComponent({list, section=''}) {
  const [blogList, setBlogList] = useState([...new Set(list)]);
  const [pageSize] = useState(12);
  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    dataLayer.push({
      event: 'view_content_list',
      content_name: 'Todas las notas',
      content_type: '',
    });
  });

  useEffect(() => {
    const bList = [...new Set(list)].sort((a, b) => {
      return new Date(b.createdDate) - new Date(a.createdDate);
    });

    setBlogList(
      bList.slice((pageNumber - 1) * pageSize, pageNumber * pageSize),
    );
  }, []);

  const PaginateComponent = ({total, pageSize}) => {
    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(total / pageSize); i++) {
      pageNumbers.push(i);
    }

    const handleOnClick = (number) => {
      setPageNumber(number);
      setBlogList(
        [...new Set(list)].slice((number - 1) * pageSize, number * pageSize),
      );

      const top = document.querySelector('.page-title');
      const topPost = top.offsetTop;
      window.scrollTo(0, topPost);
    };
    return (
      <div className="pagination-container w-full mt-10 xs:pb-10">
        <ul className="pagination flex mx-auto justify-center items-center">
          <li>
            <button
              className="bg-white text-purple-120 rounded-full btn-prev"
              onClick={() => {
                pageNumber > 1 && handleOnClick(pageNumber - 1);
              }}
            >
              Anterior
            </button>
          </li>
          {pageNumbers.map((number) => {
            if (number > pageNumber - 1 && number < pageNumber + 4) {
              return (
                <li key={number}>
                  <button
                    onClick={() => {
                      handleOnClick(number);
                    }}
                    className={`bg-white text-purple-120 rounded-full text-center ${
                      number == pageNumber ? 'btn-active' : ''
                    }`}
                  >
                    {number}
                  </button>
                </li>
              );
            }
          })}
          <li>
            <button
              className="bg-white text-purple-120 rounded-full btn-next"
              onClick={() => {
                pageNumber < pageNumbers.length &&
                  handleOnClick(pageNumber + 1);
              }}
            >
              Siguiente
            </button>
          </li>
        </ul>
      </div>
    );
  };

  const handleBlogSelectContent = (evt) => {
    evt.preventDefault();
    const {target} = evt;
    dataLayer.push({
      event: 'select_content', //Static data
      content_name:
        evt.target.parentElement.parentElement.children[0].innerText, //Dynamic data
      content_type:
        evt.target.parentElement.parentElement.parentElement.children[0]
          .children[0].innerHTML, //Dynamic data
    });
    window.location.href = target.href;
  };
  const handleBlogSelectContentImage = (evt) => {
    try{
      evt.preventDefault();
      const {target} = evt;
      dataLayer.push({
        event: 'select_content', //Static data
        content_name:
          evt.target.parentElement.parentElement.children[1].childNodes[0]
            .innerText, //Dynamic data
        content_type: evt.target.parentElement.children[0].innerText, //Dynamic data
      });
      // window.location.href = target.href;
    }catch(e){}
  };

  return (
    <div>
      <div className="grid grid-cols-3 xs:grid-cols-1 gap-5 mt-5">
        {blogList.map((item) => {
          return (
            <div
              key={item._id}
              className="blog-card-wrapper overflow-hidden relative bg-white rounded-md shadow-md"
            >
              <div className="blog-image-wrapper overflow-hidden relative">
                {item.categories && item.categories.length > 0 && (
                  <Link
                    to={`/blog/categoria/${item.categories[0].slug.current}`}
                    className="tag-item blog-tag-item z-20 absolute top-2 left-2 rounded-full border-0"
                  >
                    {section === 'tag' ? (
                      <>{item.blogTags[0].title}</>
                    ):(
                      <>{item.categories[0].name}</>
                    )}
                    
                  </Link>
                )}
                {item?.featuredImage != null && (
                  <>
                    <Link
                      to={`blog/${item?.slug?.current}`}
                      className="blog-list-image img-animate h-[279px] xs:h-full"
                      // style={{
                      //   backgroundSize: 'cover !important',
                      //   backgroundPosition: 'center center',
                      //   backgroundImage: `url(${item?.featuredImage?.asset?.url+'?w=3802&h=189'})`,
                      //   backgroundRepeat: 'no-repeat',
                      // }}
                      onClick={(evt) => handleBlogSelectContentImage(evt)}
                    >
                      <Image
                        src={item?.featuredImage?.asset?.url+'?w=3802&h=189'}
                        height={'100%'}
                        width={'100%'}
                        className="blog-list-image img-animate h-[279px] xs:h-full"
                        alt={item?.title}
                      />
                    </Link>
                  </>
                )}
              </div>
              <div className="p-4 xs:pb-2 w-full blog-card-content">
                <h3 className="text-purple-120 font-semibold card-title xs:mb-0">
                  <Link
                    className="hover:underline text-left block"
                    to={`blog/${item.slug.current}`}
                    onClick={(evt) => handleBlogSelectContent(evt)}
                  >
                    {item.title}
                  </Link>
                </h3>
                {item.excerpt && (
                  <div className="block text-left blog-excerpt xs:hidden">
                    {item.excerpt.length > 100
                      ? item.excerpt.slice(0, 100) + '...'
                      : item.excerpt}
                  </div>
                )}
                <div className="blog-read-more xs:px-4 xs:text-left left-0 bottom-0 absolute text-right w-full px-4 pb-2">
                  <Link
                    to={`blog/${item.slug.current}`}
                    className="blog-excerpt text-blue-55 font-semibold hover:underline"
                    onClick={(evt) => handleBlogSelectContent(evt)}
                  >
                    Ver nota completa
                  </Link>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <PaginateComponent
        total={[...new Set(list)].length}
        pageSize={pageSize}
      />
    </div>
  );
}
